import { useId } from 'react';

import { type IconComponentBaseProps } from '@/components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type ErrorOutlineProps = IconComponentBaseProps;

export const ErrorOutline = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: ErrorOutlineProps) => {
  const id = useId();

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id={id} style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill={fill} />
      </mask>
      <g mask={`url(#${id})`}>
        <path
          d="M12.573 16.4962C12.7295 16.3397 12.8077 16.1487 12.8077 15.923C12.8077 15.6973 12.7295 15.5063 12.573 15.35C12.4167 15.1937 12.2257 15.1155 12 15.1155C11.7743 15.1155 11.5833 15.1937 11.427 15.35C11.2705 15.5063 11.1923 15.6973 11.1923 15.923C11.1923 16.1487 11.2705 16.3397 11.427 16.4962C11.5833 16.6526 11.7743 16.7307 12 16.7307C12.2257 16.7307 12.4167 16.6526 12.573 16.4962ZM12.5345 12.8613C12.6782 12.7176 12.75 12.5395 12.75 12.327V7.827C12.75 7.6145 12.6781 7.43633 12.5343 7.2925C12.3904 7.14883 12.2122 7.077 11.9997 7.077C11.7871 7.077 11.609 7.14883 11.4655 7.2925C11.3218 7.43633 11.25 7.6145 11.25 7.827V12.327C11.25 12.5395 11.3219 12.7176 11.4658 12.8613C11.6096 13.0051 11.7878 13.077 12.0003 13.077C12.2129 13.077 12.391 13.0051 12.5345 12.8613ZM12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9982 2.5C13.3122 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9982C21.5 13.3122 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
